import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Calendar from './Calendar';
import EmergencyAlerts from './EmergencyAlerts';
import Guidelines from './Guidelines';
import IncidentReporting from './IncidentReporting';
import LostAndFound from './LostAndFound';
import News from './News';
import Expenses from './Expenses';

// Details Pages
import AlertDetailsPage from './AlertDetailsPage';
import CalendarEventDetailsPage from './CalendarEventDetailsPage';
import GuidelineDetailsPage from './GuidelineDetailsPage';
import IncidentDetailsPage from './IncidentDetailsPage';
import LostAndFoundDetailsPage from './LostAndFoundDetailsPage';
import NewsDetailsPage from './NewsDetailsPage';

const CommunityRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/community/calendar" replace />} />
      
      {/* List Pages */}
      <Route path="/calendar" element={<Calendar />} />
      <Route path="/emergency-alerts" element={<EmergencyAlerts />} />
      <Route path="/guidelines" element={<Guidelines />} />
      <Route path="/incidents" element={<IncidentReporting />} />
      <Route path="/lost-and-found" element={<LostAndFound />} />
      <Route path="/news" element={<News />} />
      <Route path="/expenses" element={<Expenses />} />
      
      {/* Details Pages */}
      <Route path="/alerts/:id" element={<AlertDetailsPage />} />
      <Route path="/calendar/:id" element={<CalendarEventDetailsPage />} />
      <Route path="/guidelines/:id" element={<GuidelineDetailsPage />} />
      <Route path="/incidents/:id" element={<IncidentDetailsPage />} />
      <Route path="/lost-and-found/:id" element={<LostAndFoundDetailsPage />} />
      <Route path="/news/:id" element={<NewsDetailsPage />} />
      
      <Route path="*" element={<Navigate to="/community/calendar" replace />} />
    </Routes>
  );
};

export default CommunityRouter; 